<template>
    <div class="recharge">
        <div class="recharge-bg"></div>
        <div class="recharge-nav">
            <img @click="goBack" class="arrow-icon" src="../../assets/img/me/icon9.png" alt="" />
            <span>{{ $t('recharge.recharge') }}</span>
            <img class="record-icon" @click="go('/record')" src="../../assets/img/me/icon8.png" alt="" />
        </div>
        <div class="placeholder"></div>
        <div class="qrcode-box">
            <div>
                <div class="title">
                    {{ $t('recharge.title') }}
                </div>
                <div class="qrcode">
                    <img :src="qrcodeUrl" alt="" />
                </div>

                <div class="label">
                    {{ $t('recharge.address') }}
                </div>
                <div class="link">0x2415ada75756c0113681f7649e9fc6aaec61bf4d</div>

                <div class="btn-box">
                    <div>
                        <img src="../../assets/img/me/icon5.png" alt="">
                        {{ $t('recharge.copy') }}
                    </div>
                    <div class="line" ></div>
                    <div class="">
                        <img src="../../assets/img/me/icon6.png" alt="">
                        {{ $t('recharge.share') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Field,
    Swipe,
    SwipeItem,
    Circle,
    Tab,
    Tabs,
    Popup,
    Progress,
    Button,
    NavBar
} from "vant";
import { copyToClipboard } from "@/utils";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";
import QRCode from 'qrcode'

export default {
    name: "recharge",
    components: {
        NavBar,
        SplitText,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            value: "",
            dd: 0.0,
            qrcodeUrl: ''
        };
    },
    computed: {},
    mounted() {
        QRCode.toDataURL('0xD50BfEf77De807F92c66AE4c7D4099Aaa5153f7a', {

            width: 260,
            height: 260,
            errorCorrectionLevel: 'L'
        })
            .then(url => {
                this.qrcodeUrl = url
            })
            .catch(err => {
                console.error(err)
            })
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        go(path) {
            this.$router.push(path)
        }
    },
};
</script>

<style lang="less" scoped>
.recharge {
    position: relative;
    overflow-x: hidden;
    flex: 1;
    height: 100%;
    background-size: 100% 800px;
    padding: 0 0 42px;
    background: url("../../assets/img/home/header-bg.png") no-repeat;
    background-size: 471.9px 240.62px;
    background-position: -60px -97px;
    display: flex;
    flex-direction: column;

    .placeholder {
        height: 44px;
    }

    &-bg {
        width: 375px;
        position: absolute;
        height: 200px;
        background: url('../../assets/img/me/header-bg.png') no-repeat center;
        top: -44px;
        background-size: 100% 100%;
    }

    .px15 {
        padding: 0 15px;
    }

    &-nav {
        position: fixed;
        max-width: 375px;
        top: 0;
        width: 100%;
        padding: 10px 20px 10px 19px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 16px;

        .arrow-icon {
            width: 24px;
            height: 24px;
        }

        .record-icon {
            width: 20px;
            height: 20px;
        }
    }

    .title {
        margin: 32px 20px 0;
        border-radius: 16px;
        border: 0.5px solid rgba(0, 0, 0, 0.2);
        font-size: 14px;
        line-height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .qrcode-box {
        margin: 34px 20px 0;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        border-radius: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        >div {
            background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
        }
    }

    .qrcode {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 32px;

        >img {
            border-radius: 20px;
            border: 1px solid #D9AF56;
        }
    }

    .label {
      font-size: 14px;
        line-height: 14px;
        text-align: center;
        margin-top: 44px;
    }

    .link {
        margin-top: 18px;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        word-break: break-all;
        flex: 1;
    }

    .btn-box {
        padding: 0 20px;
        display: flex;
        justify-content: center;
        margin-top: 32px;
        margin-bottom: 32px;
        align-items: center;
        >div {
            border: 0.5px solid rgba(0, 0, 0, 0.2);
            border-radius: 16px;
            cursor: pointer;
            font-size: 14px;
            font-weight: 500;
            display: flex;
            align-items: center;
            justify-content: center;

            >img {
                width: 20px;
                height: 20px;
                margin-right: 8px;
            }
        }
        .line{
            background: #D9D9D9;
            opacity: 0.1;
            width: 1px;
            height: 8px;
            margin: 0 27px;
        }

    }
}
</style>
<style lang="less"></style>